import React, { useEffect, useRef } from 'react';
import { func, node } from 'prop-types';

export const StickyActionObserver = ({ children, setIntersecting }) => {
  const ref = useRef(null);
  let observer = null;

  const disconnect = () => {
    if (observer && observer?.disconnect) {
      observer.disconnect();
    }
  };

  useEffect(() => {
    return () => { disconnect(); };
  }, []);

  useEffect(() => {
    observer = new IntersectionObserver(async ([entry]) => {
      if (entry.intersectionRatio < 0) return;
      setIntersecting(entry.isIntersecting);
    });

    observer.observe(ref.current);

  }, [ref]);

  return (
    <div data-testid="sticky-action-observer" style={{ width: '100%' }} ref={ref}>
      {children}
    </div>
  );
};

StickyActionObserver.propTypes = {
  children: node.isRequired,
  setIntersecting: func.isRequired
};